import { render, staticRenderFns } from "./PrivacyView.vue?vue&type=template&id=40ff8768"
var script = {}
import style0 from "./PrivacyView.vue?vue&type=style&index=0&id=40ff8768&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports